import templateStr from 'text!./templates/gateway-notes.html';
import 'portalConfig';

export default ['$stateParams', '$filter', 'PolicyService', 'AccountService', 'SubmissionService', 'ActivityService', 'UserService', 'ViewModelService', ($stateParams, $filter, PolicyService, AccountService, SubmissionService, ActivityService, UserService, ViewModelService) => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            notes: '=',
            emptyListMessage: '@emptyMessage',
            createLabel: '@createLabel',
            disableAddNote: '@',
            policyNumber: '@',
            accountNumber: '@',
            jobNumber: '@',
            activityId: '@'
        },

        link: (scope) => {
            function checkCreateNotePermission() {
                const permissionDTO = {
                    permission: 'notecreate'
                };

                const permCheckPromise = UserService.hasUserSystemPermission(permissionDTO);

                permCheckPromise.then((canCreateNote) => {
                    scope.canCreateNote = canCreateNote;
                });
            }

            scope.shouldShowAddButton = () => {
                if ((angular.isDefined(scope.disableAddNote) && (scope.disableAddNote === 'true')) || scope.addNoteFormVisible) {
                    return false;
                }

                return scope.canCreateNote;
            };

            scope.notesQuery = '';
            scope.filteredNotes = scope.notes || [];
            scope.addNoteFormVisible = false;
            scope.canCreateNote = false;
            checkCreateNotePermission();

            scope.$watchCollection('notes', (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    scope.filteredNotes = scope.notes;
                    scope.$emit('notesUpdated', scope.notes);
                }
            });

            scope.$watch('notesQuery', () => {
                scope.applyFilter();
            });

            scope.applyFilter = () => {
                scope.filteredNotes = $filter('filter')(scope.notes, scope.notesQuery);
            };

            scope.showAddNoteForm = () => {
                scope.note = {
                    subject: '',
                    body: ''
                };

                scope.addNoteFormVisible = true;
                scope.noteView = ViewModelService.create(scope.note, 'pc', 'edge.capabilities.gateway.note.dto.NoteDTO');
            };

            scope.hideAddNoteForm = () => {
                scope.addNoteFormVisible = false;
            };

            scope.saveNote = (form) => {
                form.submitted = true;
                if (form.invalid) {
                    return;
                }

                if (angular.isDefined(scope.policyNumber)) {
                    scope.saveNotePromise = PolicyService.createNoteForPolicy(scope.policyNumber, scope.note).then((createdNote) => {
                        scope.hideAddNoteForm();
                        scope.notes.push(createdNote);
                    });
                } else if (angular.isDefined(scope.accountNumber)) {
                    scope.saveNotePromise = AccountService.createNoteForAccount(scope.accountNumber, scope.note).then((createdNote) => {
                        scope.hideAddNoteForm();
                        scope.notes.push(createdNote);
                    });
                } else if (angular.isDefined(scope.jobNumber)) {
                    scope.saveNotePromise = SubmissionService.createNoteForSubmission(scope.jobNumber, scope.note).then((createdNote) => {
                        scope.hideAddNoteForm();
                        scope.notes.push(createdNote);
                    });
                } else if (angular.isDefined(scope.activityId)) {
                    scope.saveNotePromise = ActivityService.createNoteForActivity(scope.activityId, scope.note).then((createdNote) => {
                        scope.hideAddNoteForm();
                        scope.notes.push(createdNote);
                    });
                }
            };
        }
    };
}];
